import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  Accordion,
  Checkbox,
  InputItem,
  Button,
  Toast,
  Badge,
  WhiteSpace,
  WingBlank,
  ActionSheet,
  Switch
} from "antd-mobile";
import { createForm } from "rc-form";
import { connect } from "dva";
import axios from "@/service/axios";
import NoneDatas from "../../../components/noneDatas"

const CheckboxItem = Checkbox.CheckboxItem;
const loginAdminMsg =
  sessionStorage.getItem("loginMsg") &&
  JSON.parse(sessionStorage.getItem("loginMsg"));

@connect(({ user, app }) => ({ user, app }))
export class BatchUserRenew extends Component {
  state = {
    funcGidArr: [],
    checkedFuncGidArr: [],
    // 勾选的功能组价格
    totalPrice: "0", 
    preValidateMonth: -1,
    type: this.props.match.params.type,
    validFlag: true,
    // 所选的用户类型
    userOldType: 0, 
    // 消耗的虚拟币
    currency: "0",
    // 消耗的续费币
    renewCurrency: "0",
    userInfo:{
      validDate: 0,
      maxValidDate:0,
    },
    userDatas: [],
    uids: [],
  };

  async componentDidMount () {
    // 账号类型初始化
    let userOldType = 0
    // 检查所勾选的用户存在与否 
    if (this.props.history.location.query ){
      let userInfoList = this.props.history.location.query.userData
      let uids = []
      userInfoList.map((item,index) => {
        uids.push(item.uid)
      }) 
      userOldType = userInfoList[0].oldType
      this.setState({
        uids: uids,
        userDatas: userInfoList
      })
    }
    await this.props.getFuncList();
    this.getPreValidateMonth();
    this.props.dispatch({
      type: "app/getCurrencyCountOfAdmin",
      payload: Array.of(loginAdminMsg.id),
    });
    this.props.dispatch({
      type: "app/getCurrencyRenewSurlpusCount",
      payload: { adminId: loginAdminMsg.id },
    });
    // 查询账号信息
    // this.props.dispatch({
    //   type: "user/getUserPttInfo",
    //   payload: {uid: this.props.match.params.uid}
    // }).then(res => {
    //   if(res.status == 200){
    //     const Info = res.data
    //     this.setState({userInfo: Info})
    //   } else {
    //     Toast.error(res.message)
    //   }
    // })
    this.setState({
      userOldType: userOldType,
    })
  }

  //获取上级管理员的时间
  getPreValidateMonth () {
    return new Promise((resolve, reject) => {
      axios.get("/api/user/admin/preferentialMonths/get").then(res => {
        if (res.status == 200 && res.data) {
          if (res.data >= 0) {
            this.setState({
              preValidateMonth: res.data,
            });
          }
        }
      });
    });
  }

  validateMonths = (rule, value, callback) => {
    if (value) {
      callback();
    } else {
      callback(new Error("请输入购买月数"));
    }
  };
  validateFgidList = (rule, value, callback) => {
    console.log(value)
    if (value) {
      if (value.length < 1) {
        callback(new Error("请选择功能组"));
      } else {
        callback();
      }
    } else {
      callback(new Error("请选择功能组"));
    }
  };
  render () {
    const { totalPrice, preValidateMonth, type, validFlag, userOldType,currency, renewCurrency, userInfo, userDatas, uids} = this.state;
    const { dispatch, form, app, funcGroupList } = this.props;
    const { currencyTotalCount, currencyUsedCount, renewSurlpusCount } = app;
    const { validateFields, getFieldProps, getFieldsValue, getFieldError, setFieldsValue } = form;

    const submit = () => {
      validateFields({ force: true }, (error, value) => {
        console.log(value);
        if (!error) {
          const BUTTONS = ["确定", "取消"];
          ActionSheet.showActionSheetWithOptions(
            {
              options: BUTTONS,
              message: "是否对选中的用户进行续费？",
              maskClosable: true,
              "data-seed": "logId",
            },
            async buttonIndex => {
              if (!buttonIndex) {
                const { months } = value;
                let m = months
                if (type == 0 && this.props.match.params.userType == 6) {
                  m = 36;
                }
                dispatch({
                  // type: type == 0 ? 'user/renewByCurrency' : 'user/renewByRenewCurrency',
                  type: 'user/batchRenew',
                  payload: {
                    uids: uids,
                    ...value,
                    validFlag: validFlag,
                    tag: true
                  },
                }).then(res => {
                  console.log(res)
                  if (res.status == 200) {
                    Toast.success(res.message);
                    setTimeout(() => window.history.go(-1), 1500);
                  } else {
                    Toast.fail(res.message);
                  }
                });
              }
            },
          );
        }
      });
    };

    // 勾选功能组
    const onChange = (e, id, item) => {
      console.log(e.target.checked, id, item);
      let arr = this.state.funcGidArr;
      if (e.target.checked) {
        arr.push(item);
      } else {
        arr.splice(arr.map(item => item.id).indexOf(id), 1);
      }

      console.log(arr);
      this.setState({
        checkedFuncGidArr: arr,
      }, () => {
        // this.setState执行完的回调
        sumTotalPrice();
      })
      setFieldsValue({
        fgids: arr.map(item => item.id),
      });
    };
    // 计算消耗币
    const sumTotalPrice = () => {
      /** 
       * 扣币数量 = 勾选的功能组价格 * 用户数量
       */
      let months = form.getFieldValue('months');
      months = months ? months : 1;

      if (preValidateMonth > 0) {
        months = 36 / preValidateMonth;
      }
      // 勾选的功能组价格
      let sumTotalPrice = 0;
      this.state.checkedFuncGidArr.filter(item => {
        sumTotalPrice += item.pttAmount;
      });
      sumTotalPrice *= months

      console.log('功能组价格:',sumTotalPrice)

       /** 
        *  oldType:   0为三年期,1为绑定三级管理员的特殊账号,4为终身,6为三年拆分一年,7为终身拆分一年,8为其他类型预留的
        *  根据账号类型区分 三年期 三年拆分 终身 终身拆分
        *  三年期账号： 续费都使用虚拟币
        *  三年拆分账号：续费时,只有不满三年时间续费使用的是续费币
        *     当前续费时间至账号的最大有效期小于一年时 使用虚拟币  
        *  终身币：不支持续费
        *  终身拆分：只使用续费币
       */
      let cu = 0
      let rcu = 0
      // 获取当前时间
      const timestamp = new Date().getTime()
      // 判定条件
      const oneTime = 1000 * 60 * 60 * 24 * 365  // 毫秒/秒/分钟/小时/天
      // 用户最大有效期
      const userMaxDate = new Date(userInfo.maxValidDate).getTime()
      // 计算时间差: 最大到期时间 - 当前时间 与 判定条件比较 
      const time = userMaxDate - timestamp
      console.log('时间',timestamp,oneTime,userMaxDate, time)
      if (userOldType == 0){
        // 三年期类型
        cu = sumTotalPrice * uids.length
      } else if(userOldType == 6 ){
        // 三年拆分类型

        // 通过时间判断
        // if(time < oneTime) {
        //   // 当前续费时间到最大有效期小于一年 使用虚拟币
        //   cu = sumTotalPrice * 1
        // } else {
        //   // 当前续费时间到最大有效期大于等于一年
        //   if (userInfo.maxValidDate == userInfo.validDate){
        //     // 到期时间等于最大到期时间
        //     cu = sumTotalPrice * 1
        //   } else {
        //     // 使用续费币
        //     rcu = sumTotalPrice * 1
        //   }
        // }
        rcu = sumTotalPrice * uids.length
      }else if(userOldType == 7){
        // 终身账号拆分类型
        rcu = sumTotalPrice * uids.length
      }
      console.log(cu,rcu)
      this.setState({
        totalPrice: sumTotalPrice.toString(),
        currency: cu.toString(),
        renewCurrency: rcu.toString(),
      })
    };

    const handleRenewMode = () => {
      this.setState({
        validFlag: !validFlag
      })
    }
    return (
      <div className="userFuncRenew">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          批量续费
        </NavBar>
        <form>
          <div>
            <List
              renderFooter={() =>
                getFieldError("fgids") ||
                getFieldError("months")
              }
            >
              <List.Item>
                <span style={{margin:'0 8px'}}>
                  可用虚拟币：{currencyTotalCount - currencyUsedCount}
                </span>
                    
                <span style={{margin:'0 8px'}}>
                  可用续费币：{renewSurlpusCount}
                </span>
              </List.Item>
              <div className="am-list-header">已选择的待续费用户</div>
              <List style={{ height: "20%", overflowY: "scroll" }}>
                { userDatas.map((item, index) => (
                  <List.Item key={index}>{item.account} - {item.name}</List.Item>
                ))}
                { userDatas.length == 0? <NoneDatas /> : ""}
              </List>
              
              <Accordion defaultActiveKey="0">
                <Accordion.Panel
                  {...getFieldProps("fgids", {
                    rules: [
                      {
                        validator: this.validateFgidList,
                      },
                    ],
                  })}
                  header={
                    <div>
                      <span className="red-star">*</span>
                      请选择功能组：
                    </div>
                  }
                >
                  <List className="my-list">
                    {funcGroupList.map(item => (
                      <CheckboxItem
                        key={item.id}
                        onChange={e =>
                          onChange(
                            e,
                            item.id,
                            item,
                          )
                        }
                      >
                        {item.name}
                      </CheckboxItem>
                    ))}
                  </List>
                </Accordion.Panel>
              </Accordion>
              <List.Item
                extra={<Switch
                  checked={this.state.validFlag}
                  onChange={() => {handleRenewMode()}}
                />}
              >
                从当前时间续费
              </List.Item>
              {/* <InputItem
                {...getFieldProps("months", {
                  rules: [
                    {
                      validator: this
                        .validateMonths,
                    },
                  ],
                  initialValue:
                    preValidateMonth > 0
                      ? (this.props.match.params.userType == 6 ? 12 : preValidateMonth)
                      : 12,
                })}
                onBlur={sumTotalPrice}
                disabled={preValidateMonth > 0}
                type="number"
                maxLength="5"
                clear
              >
                <i className="red-star">*</i>
                购买月数：
              </InputItem> */}
              {/* <List.Item>
                {type == 0 ? '虚拟' : '续费'}币消耗：
                <Badge text={totalPrice}
                  style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
              </List.Item> */}
              <List.Item>
                虚拟币消耗：
                <Badge text={currency}
                  style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
              </List.Item>
              <List.Item>
                续费币消耗：
                <Badge text={renewCurrency}
                  style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
              </List.Item>
            </List>
            <WhiteSpace size="lg" />
            <WingBlank>
              <Button onClick={submit} type="primary">
                确定
              </Button>
              <WhiteSpace size="lg" />
              <Button onClick={() => this.props.history.goBack()}>
                返回
              </Button>
            </WingBlank>
          </div>
        </form>
      </div>
    )
  }
}

const BatchUserRenewForm = createForm()(BatchUserRenew);
const mapStateToProps = state => {
  return {
    funcGroupList: state.app.funcGroupList,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getFuncList: () => {
      dispatch({
        type: "app/getFuncGroupList",
        payload: {},
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BatchUserRenewForm);
